/**
 * Sous-titres Wolof alignés sur la voix enregistrée (STT ElevenLabs).
 * Source : native-wo.transcripts.json (généré par transcribe-native-wo.mjs).
 */

import transcripts from './native-wo.transcripts.json' with { type: 'json' };

/**
 * Remplace le texte des scènes WO par la transcription native si disponible.
 * @param {string} roleKey
 * @param {Array<object>} scenes
 */
export function applyNativeWoTranscripts(roleKey, scenes) {
  const byScene = transcripts?.roles?.[roleKey]?.scenes;
  if (!byScene || !Object.keys(byScene).length) return scenes;

  return scenes.map((s) => {
    const t = byScene[s.id];
    if (!t?.text?.trim()) return s;
    return {
      ...s,
      text: t.text.trim(),
      keyword: t.keyword || s.keyword,
    };
  });
}

/**
 * @param {string} roleKey
 * @returns {boolean}
 */
export function hasNativeWoTranscripts(roleKey) {
  const scenes = transcripts?.roles?.[roleKey]?.scenes;
  return !!scenes && Object.values(scenes).some((s) => s?.text?.trim());
}
